import * as d3 from 'd3';
import * as _ from 'lodash';

import { ILoggerService } from '../general';
import { IStatistics } from '../../models';

export interface IStatisticsService {
    getStatistics: (data: any[]) => IStatistics;
}

export class StatisticsService implements IStatisticsService {
    static serviceId = 'statisticsService';
    static $inject = ['loggerService'];
    constructor(private loggerService: ILoggerService) {

    }

    getStatistics(data: any[]): IStatistics {
        let result: IStatistics;
        if (data.length > 0) {
            const average = d3.mean(data, (d: any) => d.average);

            const prepared = [];
            data.forEach((d, i) => {
                if (d.average !== null && d.average !== undefined) {
                    prepared.push({
                        i: i,
                        value: d.average
                    });
                }
            });
            const xSeries = _.map(prepared, 'i');
            const ySeries = _.map(prepared, 'value');
            const standardDeviation = this.stdDev(average, ySeries);
            const stats = this.leastSquares(xSeries, ySeries);
            const slope = stats[0];
            const intercept = stats[1];
            result = {
                average: average,
                stdDev: standardDeviation,
                slope: slope,
                intercept: intercept,
                valuesCount: xSeries ? d3.max(xSeries, (x: any) => x) : null
            };
        } else {
            result = {
                average: null,
                stdDev: null,
                intercept: null,
                slope: null,
                valuesCount: null
            };
        }
        return result;
    }


    private stdDev(mean: number, values): number {
        const total = d3.sum(values, (d: any) => Math.pow(d - mean, 2));
        const avg = total / values.length;
        const standardDeviation = Math.sqrt(avg);
        return standardDeviation;
    }

    // from http://bl.ocks.org/benvandyke/8459843
    private leastSquares(xSeries, ySeries) {
        try {
            if (xSeries.length > 0 && ySeries.length > 0) {
                const reduceSumFunc = (prev, cur) => (prev + cur);
                const xBar = xSeries.reduce(reduceSumFunc) * 1.0 / xSeries.length;
                const yBar = ySeries.reduce(reduceSumFunc) * 1.0 / ySeries.length;
                const ssXX = xSeries.map(d => Math.pow(d - xBar, 2))
                    .reduce(reduceSumFunc);
                const ssYY = ySeries.map(d => Math.pow(d - yBar, 2))
                    .reduce(reduceSumFunc);
                const ssXY = xSeries.map((d, i) => ((d - xBar) * (ySeries[i] - yBar)))
                    .reduce(reduceSumFunc);
                const slope = ssXY / ssXX;
                const intercept = yBar - (xBar * slope);
                const rSquare = Math.pow(ssXY, 2) / (ssXX * ssYY);

                return [slope, intercept, rSquare];
            } 
            return [null, null, null];
        } catch (e) {
            this.loggerService.logError(e, false);
        }
    }
}